class t extends HTMLElement {
  constructor() {
    super(), this.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 16 16"><path fill-rule="evenodd" d="m8 3.26 1.38 2.79.23.5.5.075 3.08.445L11 9.22l-.375.365.09.5.525 3.065-2.755-1.445L8 11.5l-.465.245L4.78 13.17l.5-3.065.09-.5L5 9.22 2.79 7.045 5.87 6.6l.5-.075.23-.5L8 3.26ZM8 1 5.725 5.61.64 6.345l3.68 3.59L3.45 15 8 12.61 12.55 15l-.87-5.065 3.68-3.585-5.085-.74L8 1Z" clip-rule="evenodd"></path></svg>';
  }
}
const e = "pi-star";
customElements.get(e) || customElements.define(e, t);
export {
  t as default
};
